function decodeBasicHtmlEntities(value: string): string {
  return value
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'");
}

function stripHtmlToPlainText(value: string): string {
  return decodeBasicHtmlEntities(
    value
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p>/gi, "\n")
      .replace(/<\/li>/gi, " ")
      .replace(/<[^>]*>/g, " ")
  )
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * Normalizes ILE recommendation copy for the course modernizer review panel.
 * Stored descriptions may be student-facing ILE HTML or mention "AI tutor".
 */
export function formatIleReviewDescription(raw: string | null | undefined): string {
  if (!raw?.trim()) {
    return "";
  }

  let text = stripHtmlToPlainText(raw);
  text = text.replace(/^purpose:\s*/i, "");
  text = text.replace(/\bAI\s+tutors?\b/gi, "Interactive Learning Experience");
  text = text.replace(/\bAxio\s+ILE\b/gi, "Interactive Learning Experience");

  return text.replace(/\s+/g, " ").trim();
}
